import { Surface } from '@ukpostbox/frontend-framework';
import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';
import { RenderBatchSectionType } from '../../Types/ForwardingBatchTypes';

function BatchNotesComplete(props: RenderBatchSectionType) {
	const { currentBatchData } = useForwardingBatchProvider();

	if (!currentBatchData?.notes) return null;

	return (
		<div>
			<h5 className='mb-xs'>{props.section.name}</h5>

			<Surface extraClass='p-md'>
				<p>{currentBatchData?.notes}</p>
			</Surface>
		</div>
	);
}

export { BatchNotesComplete };
